document.addEventListener("DOMContentLoaded", () => {
  function updateStepOnScroll() {
    const steps = document.querySelectorAll(".scroll-step");
    let currentStep = null;

    steps.forEach((step) => {
      const rect = step.getBoundingClientRect();
      if (
        rect.top <= window.innerHeight / 2 &&
        rect.bottom > window.innerHeight / 2
      ) {
        currentStep = step.dataset.step;
      }
    });

    // Progress bar update
    const progressBar = document.getElementById("scroll-progress-bar");
    // If the user is at the very top of the page, force progress to first step
    if (window.scrollY <= 0) {
      if (progressBar && steps.length > 0) {
        const scrollContainer = document.querySelector(".scroll");
        const firstStepEl = steps[0];
        if (scrollContainer && firstStepEl) {
          const scrollTop = scrollContainer.offsetTop;
          const stepOffset = firstStepEl.offsetTop - scrollTop;
          const stepHeight = firstStepEl.offsetHeight;
          progressBar.style.height = `${stepOffset + stepHeight / 2}px`;
        }
      }
      return;
    }
    const totalSteps = steps.length;
    const activeIndex = [...steps].findIndex(
      (step) => step.dataset.step === currentStep
    );
    if (progressBar && activeIndex >= 0) {
      const scrollContainer = document.querySelector(".scroll");
      const currentStepEl = steps[activeIndex];
      if (scrollContainer && currentStepEl) {
        if (activeIndex === totalSteps - 1) {
          progressBar.style.height = `${scrollContainer.offsetHeight}px`;
        } else {
          const scrollTop = scrollContainer.offsetTop;
          const stepOffset = currentStepEl.offsetTop - scrollTop;
          const stepHeight = currentStepEl.offsetHeight;
          progressBar.style.height = `${stepOffset + stepHeight / 2}px`;
        }
      }
    }
  }

  window.addEventListener("scroll", updateStepOnScroll);
  updateStepOnScroll();
});
